var data = {
	"body": "<g fill=\"none\"><path d=\"M37.75 9c2.9 0 5.25 2.35 5.25 5.25v19.5c0 2.9-2.35 5.25-5.25 5.25h-27.5A5.25 5.25 0 0 1 5 33.75v-19.5C5 11.35 7.35 9 10.25 9h27.5zm2.75 9.351l-15.898 8.744a1.25 1.25 0 0 1-1.077.061l-.127-.06L7.5 18.35V33.75a2.75 2.75 0 0 0 2.75 2.75h27.5a2.75 2.75 0 0 0 2.75-2.75V18.351zM37.75 11.5h-27.5a2.75 2.75 0 0 0-2.75 2.75v1.249L24 24.573l16.5-9.075V14.25a2.75 2.75 0 0 0-2.75-2.75z\" fill=\"currentColor\"/></g>",
	"width": 48,
	"height": 48
};
export default data;
